import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { useAppContext } from '../../context/AppContext';
import { getSolutionsDirectoryUrl, getTemplateMarketplaceUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function StorefrontNavText({
  children
}) {
  return /*#__PURE__*/_jsx(Text, {
    children: children
  });
}
export function StorefrontNav() {
  const appContext = useAppContext();
  const lang = getLang();
  return /*#__PURE__*/_jsx("nav", {
    "aria-label": "Marketplace navigation",
    children: /*#__PURE__*/_jsxs(List, {
      inline: true,
      marginBlockStart: "500",
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginInlineEnd: "1000",
        children: /*#__PURE__*/_jsx(UIRouterLink, {
          to: Paths.AGENTS,
          children: /*#__PURE__*/_jsx(StorefrontNavText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.storefrontNav.agents"
            })
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginInlineEnd: "1000",
        children: /*#__PURE__*/_jsx(UIRouterLink, {
          to: Paths.APPS,
          children: /*#__PURE__*/_jsx(StorefrontNavText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.storefrontNav.apps"
            })
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginInlineEnd: "1000",
        children: /*#__PURE__*/_jsx(Link, {
          href: getTemplateMarketplaceUrl(appContext, lang),
          children: /*#__PURE__*/_jsx(StorefrontNavText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.storefrontNav.templates"
            })
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Link, {
          href: getSolutionsDirectoryUrl(appContext, lang),
          children: /*#__PURE__*/_jsx(StorefrontNavText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.storefrontNav.solutionsPartners"
            })
          })
        })
      })]
    })
  });
}